import { DataTableRowsPerPage, useDataTableRowsPerPage } from './useDataTableRowsPerPage'
import { DataTableSort, useDataTableSort } from './useDataTableSort'

export type NestedDataTableState<TColumnId extends string> = {
    sort: DataTableSort<TColumnId>
    rowsPerPageState: DataTableRowsPerPage
}

export const useNestedDataTableState = <TColumnId extends string>(
    defaultSortColumnId?: TColumnId
): NestedDataTableState<TColumnId> => ({
    sort: useDataTableSort<TColumnId>(defaultSortColumnId),
    rowsPerPageState: useDataTableRowsPerPage(),
})
